import { ThemeProvider } from "@mui/material";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import store from "redux/store";
import router from "routers";
import theme from "theme";
import { ToastContainer } from "react-toastify";
import GlobalBackdrop from "components/globalBackdrop";

import "react-toastify/dist/ReactToastify.css";
import "simplebar-react/dist/simplebar.min.css";
// import { useEffect } from "react";
// import { setUpScript } from "hooks/useUmami";
function App() {
    // useEffect(() => {
    //     setUpScript({
    //         host: import.meta.env.VITE_UMAMI_HOST,
    //         dataWebSiteId: import.meta.env.VITE_UMAMI_WEBSITE_ID
    //     });
    // }, []);

    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <RouterProvider router={router} />
                <ToastContainer
                    position="top-right"
                    autoClose={2000}
                    hideProgressBar={true}
                    newestOnTop={true}
                    closeOnClick
                />
                <GlobalBackdrop />
            </ThemeProvider>
        </Provider>
    );
}

export default App;
